import { UpdateBusinessCategoryComponent } from './update-business-category/update-business-category.component'
import { CreateBusinessCategoryComponent } from './create-business-category/create-business-category.component'
import { BusinessCategoriesComponent } from './business-categories.component'
import { MainLayoutComponent } from '@components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'
import { CreateBusinessSubcategoryComponent } from './create-business-subcategory/create-business-subcategory.component'
import { UpdateBusinessSubcategoryComponent } from './update-business-subcategory/update-business-subcategory.component'

export const businessCategoriesRoutes: Routes = [
  {
    path: 'admin/license-categories',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_CONFIGURATION_PANEL',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: BusinessCategoriesComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreateBusinessCategoryComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdateBusinessCategoryComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/subcategories/create',
        component: CreateBusinessSubcategoryComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/subcategories/:sid/update',
        component: UpdateBusinessSubcategoryComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
